import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import http from './api/http'
import ElementUI from 'element-ui'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import Clipboard from 'vue-clipboard2'
import Layout from './components/layout/appMain'
import _ from 'lodash'

//定义全局
localStorage.setItem('wsUrl', `${process.env.VUE_APP_WS}`)

Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.use(Clipboard)

Vue.prototype.$http = http
Vue.prototype._ = _

let app = new Vue({
  router,
  store,
  component: { Layout },
  template: '<Layout/>',
  render: h => h(App)
}).$mount('#app')

